import { render, staticRenderFns } from "./SelectWaresDrug.vue?vue&type=template&id=60119220&scoped=true&"
import script from "./SelectWaresDrug.vue?vue&type=script&lang=js&"
export * from "./SelectWaresDrug.vue?vue&type=script&lang=js&"
import style0 from "./SelectWaresDrug.vue?vue&type=style&index=0&id=60119220&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60119220",
  null
  
)

export default component.exports